import { FC, useState } from "react";
import { PatientDetailsWithId } from "../../types";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import RemovePatientDialog from "./RemovePatientDialog";
import AvatarInitialsProfile from "../AvatarInitialsProfile";

interface PatientCardProps {
  patient: PatientDetailsWithId;
  handleRemove: (patientId: string) => void;
}

const PatientCard: FC<PatientCardProps> = ({ patient, handleRemove }) => {
  const [open, setOpen] = useState(false);
  const fullName = `${patient.firstName} ${patient.lastName}`;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRemoveAndClose = () => {
    handleRemove(patient.patientId);
    handleClose();
  };

  return (
    <>
      <Card variant="outlined" sx={{ padding: "0.5rem", paddingLeft: "1rem" }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <AvatarInitialsProfile
            firstName={patient.firstName}
            lastName={patient.lastName}
          />
          <Box flexGrow={1}>
            <Typography variant="body1">{fullName}</Typography>
            <Typography variant="caption">{patient.email}</Typography>
          </Box>
          <Button href={`/patients/${patient.patientId}`}>Go to profile</Button>
          <Button color="error" onClick={handleOpen}>
            Remove
          </Button>
        </Stack>
        <RemovePatientDialog
          patient={patient}
          handleClose={handleClose}
          handleRemoveAndClose={handleRemoveAndClose}
          open={open}
        />
      </Card>
    </>
  );
};

export default PatientCard;
